// src/lib/livret-video-client.js — Phase A.7.1b (ADR-120)
//
// SEULE COPIE — l'ancienne copie serveur lib/livret-video.js n'était importée
// par aucun fichier ; elle a été retirée le 03/10 (récupérable par l'étiquette
// git archive/code-mort-p4). Rien à reporter ailleurs.
//
// Helpers extraction ID YouTube/Vimeo + génération URL embed côté browser.
// Utilisés par PublicLivretPage (rendu voyageur iframe sandbox) ET
// LivretModuleEditor (validation client preview WYSIWYG).

// Regex stricte : accepte https://(www.)?youtube.com/watch?v=ID ou https://youtu.be/ID
// ID = exactement 11 chars alphanumériques + _- (spec YouTube).
// Suffix optionnel : query string (?param=...) OU param additionnel (&t=42s).
export const YOUTUBE_REGEX =
  /^https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:[?&][^\s]*)?$/;

// Regex stricte : accepte https://(www.)?vimeo.com/123456789
// ID = 6 à 12 chiffres (range observé Vimeo public IDs).
// Suffix optionnel : query string ou param additionnel.
export const VIMEO_REGEX =
  /^https?:\/\/(?:www\.)?vimeo\.com\/(\d{6,12})(?:[?&][^\s]*)?$/;

/**
 * Extrait l'ID YouTube depuis une URL standard ou short.
 *
 * @param {unknown} url
 * @returns {string|null} — ID 11 chars ou null si format invalide
 */
export function extractYouTubeId(url) {
  if (typeof url !== "string" || url.length === 0) return null;
  const m = url.match(YOUTUBE_REGEX);
  return m ? m[1] : null;
}

/**
 * Extrait l'ID Vimeo depuis une URL standard.
 *
 * @param {unknown} url
 * @returns {string|null} — ID numérique ou null si format invalide
 */
export function extractVimeoId(url) {
  if (typeof url !== "string" || url.length === 0) return null;
  const m = url.match(VIMEO_REGEX);
  return m ? m[1] : null;
}

/**
 * Valide qu'une URL vidéo est YouTube ou Vimeo conforme regex stricte.
 *
 * @param {unknown} url
 * @returns {{ok:true, provider:'youtube'|'vimeo', id:string} | {ok:false, message:string}}
 */
export function validateVideoUrl(url) {
  if (typeof url !== "string" || url.length === 0) {
    return { ok: false, message: "video_url doit être string non vide" };
  }
  const ytId = extractYouTubeId(url);
  if (ytId) return { ok: true, provider: "youtube", id: ytId };
  const vmId = extractVimeoId(url);
  if (vmId) return { ok: true, provider: "vimeo", id: vmId };
  return {
    ok: false,
    message:
      "video_url doit être YouTube (youtube.com/watch?v= ou youtu.be/) ou Vimeo (vimeo.com/ID)",
  };
}

/**
 * Génère l'URL embed pour iframe rendu voyageur.
 * YouTube → youtube-nocookie.com (privacy mode).
 * Vimeo   → player.vimeo.com.
 *
 * @param {'youtube'|'vimeo'} provider
 * @param {string} id
 * @returns {string|null} — URL embed ou null si provider invalide
 */
export function getEmbedUrl(provider, id) {
  if (typeof id !== "string" || id.length === 0) return null;
  if (provider === "youtube") {
    return `https://www.youtube-nocookie.com/embed/${id}`;
  }
  if (provider === "vimeo") {
    return `https://player.vimeo.com/video/${id}`;
  }
  return null;
}

/**
 * Helper combiné : URL brute → URL embed (ou null si invalide).
 *
 * @param {unknown} url
 * @returns {string|null}
 */
export function videoUrlToEmbed(url) {
  const v = validateVideoUrl(url);
  if (!v.ok) return null;
  return getEmbedUrl(v.provider, v.id);
}
